import { Box, Grid, IconButton, Typography } from "@mui/material"
import { useDispatch, useSelector } from "react-redux";
import { fontFamilySelector, templateSelector, themeSelector } from "../../services/ThemeSlice";
import { getTextStyles } from "../../style/textStyles";
import Card17 from "../Card/Card17";
import { setEditData } from "../../services/EditingSlice";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import { authTokenSelector, editPortfilio } from "../../services/TemplateSlice";
import { shiftElementsByPosition } from "../../editingComponents/Helpers";
import { Add } from "@mui/icons-material";

const Project4 = ({details}) => {
    const template = useSelector(templateSelector)
    const theme = useSelector(themeSelector)
    const fontFamily = useSelector(fontFamilySelector)
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const authToken = useSelector(authTokenSelector);
    const [dragState, setDragState] = useState(null);

    const dispatch = useDispatch();

    const openEditProject = (details, i, arrayContent) => {
        dispatch(setEditData({
            editType: 'multi-text',
            editContent: typeof(i) === 'number' ? details : {btnText: 'Read More'},
            editSubType: typeof(i) === 'number' ? '' : 'array',
            arrayContent: arrayContent,
            arrayIndex: i,
            editingFields: [
                {key: 'name', label: 'Project Name'},
                {key: 'intro', label: 'Description'},
                {key: 'technologies', label: 'Technologies Used'}
            ],
            editTitle: 'Edit Project',
            path: typeof(i) === 'number' ? `sections[2].projects[${i}].name,sections[2].projects[${i}].intro,sections[2].projects[${i}].technologies` : `sections[2].projects`,
            deletePath: `sections[2].projects`,
        }))
    }
    
    return(
        <Grid container spacing={1} style={{display:'flex', justifyContent: 'center'}}>
            <Grid item xs={12} sm={12} md={12} lg={12} style={{paddingBottom: '3vw'}}>
                <Typography variant="h1" style={{...getTextStyles(template, 'header1', {}), ...{color: theme.light.info, fontFamily: fontFamily.primary}}}>{details?.title}
                {Boolean(authToken) && authToken === queryParams.get('authToken') && <IconButton style={{marginBottom: 10, color: '#000', marginLeft: 10}} onClick={() => openEditProject(undefined, undefined, details?.projects)}><Add/></IconButton>}
                </Typography>
            </Grid>
            {details?.projects?.map((project, i) => (
                <Grid item key={i} xs={12} sm={12} md={6} lg={6} style={{margin: '2vw 0'}}>
                    <Box style={{padding: '2vw', display: 'flex', justifyContent: 'center', height: '100%', cursor: Boolean(authToken) && authToken === queryParams.get('authToken') ? 'move' : 'default'}}
                        draggable={Boolean(authToken) && authToken === queryParams.get('authToken')} 
                        onDragEnd={(event) => {
                            dispatch(editPortfilio(`sections[2].projects`, shiftElementsByPosition(details?.projects, i + 1, dragState + 1), queryParams.get('authToken'), null, 'array'));
                        }} 
                        onDragOver={() => setDragState(i)}>
                        <Card17 content={project} doubleClick={() => openEditProject(project, i, details?.projects)}/>
                    </Box>
                </Grid>
            ))}
        </Grid>
    )
}

export default Project4;